import BaseController from "src/controller/BaseController.js";
import ApiUrls from "src/routes/api";
import { Api } from "src/utils";

class LearningPlanController extends BaseController {
  _put = ApiUrls.learningPlan.update;
  _get = ApiUrls.learningPlan.getByStudentId;
  _delete = ApiUrls.learningPlan.delete;

  async getPublicLink(data) {
    return new Promise((resolve, reject) => {
      Api.post(ApiUrls.learningPlan.getPublicLink, data)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export default new LearningPlanController();
